import HappyIcon from './component'

export default HappyIcon
